module.exports = __webpack_public_path__ + "static/img/solutions2.e9e5e1fd.png";